if (!customElements.get("video-player")) {
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector("video");
      this.button = this.querySelector(".btn-play");

      if (this.video.paused) {
        this.button.classList.add("btn-play--active");
      } else {
        this.button.classList.remove("btn-play--active");
      }
    }

    connectedCallback() {
      this.addEventListener("click", e => {
        if (e.target === this.video && this.video.hasAttribute("controls")) {
          return;
        }
        if (this.classList.contains("is-playing")) {
          this.video.pause();
        } else {
          this.video.play();
        }
      });

      this.observeStatus();
    }

    observeStatus() {
      this.video.addEventListener("play", () => {
        this.classList.add("is-playing");
        this.button.classList.remove("btn-play--active");
        if (this.video.hasAttribute("data-show-controls") && this.video.getAttribute("data-show-controls") === "true") {
          this.video.toggleAttribute("controls", true);
          this.button.classList.add("hidden");
        }
      });
      this.video.addEventListener("pause", () => {
        this.classList.remove("is-playing");
        this.button.classList.add("btn-play--active");
        if (this.video.hasAttribute("data-show-controls") && this.video.getAttribute("data-show-controls") === "true") {
          this.video.toggleAttribute("controls", false);
          this.button.classList.remove("hidden");
        }
      });
      this.video.addEventListener("ended", () => {
        this.classList.remove("is-playing");
        this.button.classList.add("btn-play--active");
        if (this.video.hasAttribute("data-show-controls") && this.video.getAttribute("data-show-controls") === "true") {
          this.video.toggleAttribute("controls", false);
          this.button.classList.remove("hidden");
        }
      });
    }
  }

  customElements.define("video-player", VideoPlayer);
}
